export class UtenteOperatoreVO {
  username: string;
  nome: string;
  cognome: string;
  id: string;
  ruoli: string[];
}
